import React, { useState } from "react";
import "./MessageCodes.css";
import Tooltip from "@mui/material/Tooltip"; // Ensure this is imported if using MUI Tooltip

const MessageA1 = (props) => {
  const {iframeRef ,setShowIframe} = props
  const [onClick, setOnClick] = useState(false);


  
  function sanitizeEncryptedString(input) {
    // Replace all Unicode \u003d with actual '='
    let cleaned = input.replace(/\\u003d/g, '=');
  
    // If it starts with '=', it's likely accidental, remove it
    if (cleaned.startsWith('=')) cleaned = cleaned.substring(1);
  
    return cleaned;
  }

  const getButtonContent = () => {
    let parsedData = null;
    try {
      parsedData = props?.item?.data ? JSON.parse(props.item.data) : null;
    } catch (e) {
      // If parsing fails, just use text as is
    }

    if (parsedData?.show === "live") {
      return `
  <div style="display:inline-block; font-family: 'VoltePlay-Medium', sans-serif; font-weight: 700;">
    ${props?.item.text}
    <span class="live-indicator ${onClick || props.disable ? 'paused' : ''}">
      LIVE
    </span>
  </div>
`;
    }
    return props?.item.text;
  };

  if (!props?.item?.text?.trim()) {
    return null;
  }

  const handleChatClick = () => {
    if (!props.disable) {
      props.handleClick(props.item.code, null, props.item.text);
      props.setTextOnClick(props.item.text);
      if (props.setChatWithAgentClicked) {
        props.setChatWithAgentClicked(true);
      }

      // const url = sanitizeEncryptedString(props?.item?.data);
      // console.log(url, "Genesys URL");

      // // Set iframe src manually
      // if (iframeRef.current) {
      //   iframeRef.current.src = url;
      //   iframeRef.current.style.display = "block";
      // }

      // setShowIframe(true);
    }
  };


 
  
  
  


  return (
    <>
      {props?.item?.infoText ? (
        <Tooltip
          title={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <h1 style={{ fontSize: 13, margin: 0 }}>{props?.item?.infoText}</h1>
            </div>
          }
          placement="top"
          arrow
          PopperProps={{
            modifiers: [
              {
                name: "preventOverflow",
                options: { boundary: "window" },
              },
              {
                name: "offset",
                options: { offset: [0, -5] }, // Adjust this value to move closer
              },
            ],
          }}
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "rgba(34, 0, 70, 0.75)",
                color: "#fff",
                fontSize: "12px",
                padding: "6px 10px",
              },
            },
            arrow: {
              sx: { color: "rgba(34, 0, 70, 0.75)" },
            },
          }}
        >
          <div className="a1-wrap disable-tooltips" style={{ width: "fit-content" }}>
            <div
              className={!onClick ? "chat-label action-tab action-button " : "chat-label-select action-tab "}
              id="main-tab1"
              // style={{ color: props.disable ? "grey" : "" }}
              onClick={() => {
                // document.body.classList.add("disable-tooltips");
                if (!props.disable) {
                  props.handleClick(props.item.code, null, props.item.text);
                  props.setTextOnClick(props.item.text);
                  props.setSubTextOnClick(props?.item?.infoText)
                  if (props.setChatWithAgentClicked) {
                    props.setChatWithAgentClicked(true);
                  }
                  setOnClick(true);
                }
              }}
              dangerouslySetInnerHTML={{ __html: getButtonContent() }}
            >
            </div></div>
        </Tooltip>
      ) : props?.item?.text === "Chat with Agent"
        ? <div className="a1-wrap" style={{ width: "fit-content" }}>
          <button
            className={!onClick ? "chat-label action-tab action-button" : "chat-label-select action-tab"}
            id="main-tab1"
            style={{ color: props.disable ? "grey" : "" , color:'white' , backgroundColor :'rgba(225, 0, 146, 1)'}}
            onClick={() => {
              handleChatClick()
      
            }}
            dangerouslySetInnerHTML={{ __html: getButtonContent() }}
          >
          </button>
        </div> : (
          <div className="a1-wrap" style={{ width: "fit-content" }}>
            <div
              className={!onClick ? "chat-label action-tab action-button" : "chat-label-select action-tab"}
              id="main-tab1"
              style={{ color: props.disable ? "grey" : "" }}
              onClick={() => {
                if (!props.disable) {
                  props.handleClick(props.item.code, null, props.item.text);
                  props.setTextOnClick(props.item.text);
                  if (props.setChatWithAgentClicked) {
                    props.setChatWithAgentClicked(true);
                  }
                  setOnClick(true);
                }
              }}
              dangerouslySetInnerHTML={{ __html: getButtonContent() }}
            >
            </div>
          </div>
        )}
    </>
  );
};

export default MessageA1;
